export default "__VITE_ASSET__CDA_$KMr__"